import { 
  getVideoList, 
  postVideo,
  updateVideo, 
  deleteVideo,
  getVideoListForPlaylist,
  postClassPersonelVideolist,
  getSuggestedVideolist,
 } from "@/services/video.service";

import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  videoModel: {},
});

// mutations
const mutations = {
  setVideoModel(state, data) {
    state.videoModel = data;
  },
};

// actions
const actions = {

  //videolist
  async loadVideoList(vuexContext, co) {
    return await getVideoList(co).then((response) => {

      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((item, index) => {
        item.index = index + 1;
        item.showYoutubeVideo = item.name;

        if (item.videoLevels) {
          item.levels = "";
          item.videoLevels.forEach((videoLevel, index) => {
            if (index != 0) {
              item.levels += ", ";
            }
            item.levels += videoLevel?.level?.description;
          });
          if (item.levels == "") {
            item.levels = "Seviye Bilgisi Bulunmamaktadır.";
          }
        }

        if (item.videosCategories) {
          item.categories = "";
          item.videosCategories.forEach((videoCategory, index) => {
            if (index != 0) {
              item.categories += ", ";
            }
            item.categories += videoCategory?.videoCategory?.name;
          });

          if (item.categories == "") {
            item.categories = "Kategori Bilgisi Bulunmamaktadır.";
          }
        }

        if (item.videoClassStatuses) {
          item.classStatus = "";
          item.videoClassStatuses.forEach((classStatus, index) => {
            if (index != 0) {
              item.classStatus += ", ";
            }
            item.classStatus += `${classStatus?.classStatus?.startTime} - ${classStatus?.classStatus?.endTime} / ${classStatus?.classStatus?.levels?.description}`;
          });

          if (item.classStatus == "") {
            item.classStatus = "Kur Bilgisi Bulunmamaktadır.";
          }
        }

        if (item.videoTags) {
          item.tags = "";
          item.videoTags.forEach((videoTag, index) => {
            if (index != 0) {
              item.tags += ", ";
            }
            item.tags += videoTag?.tag?.description;
          });

          if(item.tags == "")
          {
            item.tags = "Etiket Bilgisi Bulunmamaktadır.";
          }
        }
      });

      setPaginationDetails(co, totalCount, totalPages);

      return items;
    });
  },

  async loadVideoListForPlaylist(vuexContext, co) {

    return await getVideoListForPlaylist(co).then((response) => {

      let data = response.data.data;
      let items = data.items;
      // let totalCount = data.totalCount;
      // let totalPages = data.totalPages;

      items.map((item, index) => {
        item.index = index + 1;

        if (item.videoLevels) {
          item.levels = "";
          item.videoLevels.forEach((videoLevel, index) => {
            if (index != 0) {
              item.levels += ", ";
            }
            item.levels += videoLevel?.level?.description;
          });
          if (item.levels == "") {
            item.levels = "Seviye Bilgisi Bulunmamaktadır.";
          }
        }

        if (item.videosCategories) {
          item.categories = "";
          item.videosCategories.forEach((videoCategory, index) => {
            if (index != 0) {
              item.categories += ", ";
            }
            item.categories += videoCategory?.videoCategory?.name;
          });

          if (item.categories == "") {
            item.categories = "Kategori Bilgisi Bulunmamaktadır.";
          }
        }

        if (item.videoClassStatuses) {
          item.classStatuses = "";
          item.videoClassStatuses.forEach((classStatus, index) => {
            if (index != 0) {
              item.classStatuses += ", ";
            }
            item.classStatuses += `${classStatus?.classStatus?.startTime} - ${classStatus?.classStatus?.endTime} / ${classStatus?.classStatus?.levels?.description}`;
          });

          if (item.classStatuses == "") {
            item.classStatuses = "Kur Bilgisi Bulunmamaktadır.";
          }
        }

        if (item.videoTags) {
          item.tags = "";
          item.videoTags.forEach((videoTag, index) => {
            if (index != 0) {
              item.tags += ", ";
            }
            item.tags += videoTag?.tag?.description;
          });

          if(item.tags == "")
          {
            item.tags = "Etiket Bilgisi Bulunmamaktadır.";
          }
        }
      });

      // setPaginationDetails(co, totalCount, totalPages);

      return items;
    });
  },

  async postVideo(vuexContext, data) {
    return await postVideo(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateVideo(vuexContext, data) {
    return await updateVideo(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteVideo(vuexContext, data) {
    return await deleteVideo(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addVideoModel(vuexContext, data) {
    vuexContext.commit("setVideoModel", data);
  },

  async postClassPersonelVideolist(vuexContext, data) {
    return await postClassPersonelVideolist(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async loadSuggestedVideolist() {    
    return await getSuggestedVideolist().then((response) => {
      let data = response.data.data;

      return data;
    });
  },  
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
